import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import { campwiseattApi } from '../../../utils/AdminDashApi/CampWiseAttApi'
import { empAttreportApi } from '../../../utils/AdminDashApi/EmpAttReportApi'
import { BsPlus } from 'react-icons/bs'
import { optionsCampus, optionsShift, optionsdayofmonth, optionsdayofweek, optionsdept, optionsdesignation, purplebutton200, purplebutton40 } from '../../Helper'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import { shiftAssignApi } from '../../../utils/AdminDashApi/ShiftAssignApi'
const ShiftAssignCompmb = () => {

    const [activefrom,setactivefrom] = useState("")
    const [activeto,setactiveTo] = useState("")
    
    const [activefrommdlnm,setactivefrommdlnm] = useState("")
    const [activetomdl,setactiveTomdl] = useState("")
    const [activetomdlnm,setactiveTomdlnm] = useState("")
   
  
    const [department,setdepartment] = useState("")
    const [labeldepartment,setlabeldepartment] = useState("")
    const [borderdepartment,setborderdepartment] = useState("")
    const [campus,setcampus]= useState("")
    const [bordercampus,setbordercampus]= useState("")
    const [labelcampus,setlabelcampus]= useState("")
    const [type,settype]= useState("")
    const [bordertype,setbordertype]= useState("")
    const [labeltype,setlabeltype]= useState("")
  
  
    const [shiftmain,setshiftmain] = useState("")
    const [bordershiftmain,setbordershiftmain] = useState("")
    const [labelshiftmain,setlabelshiftmain] = useState("")
  
    const [shifttypemain,setshifttypemain] = useState("")
    const [bordershifttypemain,setbordershifttypemain] = useState("")
    const [labelshifttypemain,setlabelshifttypemain] = useState("")
  
    const [startdatemain,setstartdatemain] = useState("")
    const [borderstartdatemain,setborderstartdatemain] = useState("")
    const [labelstartdatemain,setlabelstartdatemain] = useState("")
  
    const [enddatemain,setenddatemain] = useState("")
    const [borderenddatemain,setborderenddatemain] = useState("")
    const [labelenddatemain,setlabelenddatemain] = useState("")
  
    const [designationmain,setdesignationmain] = useState("")
    const [borderdesignationmain,setborderdesignationmain] = useState("")
    const [labeldesignationmain,setlabeldesignationmain] = useState("")
    
    const [campusmain,setcampusmain] = useState("")
    const [bordercampusmain,setbordercampusmain] = useState("")
    const [labelcampusmain,setlabelcampusmain] = useState("")
    
    const [employeeIDmain,setemployeeIDmain] = useState("")
    const [borderemployeeIDmain,setborderemployeeIDmain] = useState("")
    const [labelemployeeIDmain,setlabelemployeeIDmain] = useState("")
    
    const [empIDmod,setempIDmod] = useState("")
    const [borderempIDmod,setborderempIDmod] = useState("")
    const [labelempIDmod,setlabelempIDmod] = useState("")
    
    const [empnamemod,setempnamemod] = useState("")
    const [borderempnamemod,setborderempnamemod] = useState("")
    const [labelempnamemod,setlabelempnamemod] = useState("")
    
    const [startdatemod,setstartdatemod] = useState("")
    const [borderstartdatemod,setborderstartdatemod] = useState("")
    const [labelstartdatemod,setlabelstartdatemod] = useState("")
    
    const [enddatemod,setenddatemod] = useState("")
    const [borderenddatemod,setborderenddatemod] = useState("")
    const [labelenddatemod,setlabelenddatemod] = useState("")
  
   
   
   
  
    const drpfunccampusmain=(myval,myid)=>{
      setcampusmain(myval)
    }
    const drpfuncdesignationmain=(myval,myid)=>{
      setdesignationmain(myval)
    }
    const drpfuncshifttypemain=(myval,myid)=>{
      setshifttypemain(myval)
    }
    const drpfuncshiftmain=(myval,myid)=>{
      setshiftmain(myval)
    }
  
    const handleStartdatemod = (activefromval)=>{
  
      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setstartdatemod(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
    const handleEnddatemod = (activefromval)=>{
  
      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setenddatemod(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
    const handleStartDatemain = (activefromval)=>{
  
      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setstartdatemain(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
    const handleenddatemain = (activefromval)=>{
  
      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setenddatemain(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
  
  const initialState = shiftAssignApi.data.map(item => ({
    ...item
  }));
    const [ischkmodal, setischkmodal] = useState([initialState]);
    const [ischkmodalall, setischkmodalall] = useState([]);
  
  
    
  
    const updateTickmark = (empid, newValue) => {
      console.log(ischkmodal[0])
  
    
      // setischkmodal(prevData => ({
      //   ...prevData,
      //   [empid]: {
      //     ...prevData[empid],
      //     tickmark: newValue
      //   }
      // }));
      var myarr = ischkmodal[0]
  
      for(var i=0;i<myarr.length;i++){
        if(empid == myarr[i].empid){
          
          myarr[i].tickmark = true
          setischkmodal(myarr)
        }
  
      }
      
      
     
    };
  const handleChangechk = (event,myid) => {
      var checkedme = ""
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
        updateTickmark(myid, true);
      } else {
        console.log('⛔️ Checkbox is NOT checked');
        updateTickmark(myid, false);
      }
      
     
    };
  
  
  
  
  
  
  
  const handleChangechkall = (event,myid) => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodalall(current => !current);
    };
  
  
  const handleSearch=()=>{
      console.log("searched")
  }
  
  
    const handleShowEdit=(e,item)=>{
      setShow3(true)
  
      
    }
  
    const bottomSave=()=>{
  
      
      const finalarr = {
          tickmart: ischkmodal.length>1?ischkmodal:ischkmodal[0],
    }
      console.log(finalarr)
    }
  
   
   
    const [roleDrp,setRoledrp] = useState("")
   
   
    const [mainpagesearch,setmainpagesearch] = useState("")
    const handlemainpagesearch=(e)=>{
      setmainpagesearch(e.target.value)
    }
    const [statusvalueerr,setstatusvalueerr] = useState("")
    const [activefromMoment,setactivefromMoment] = useState("")
  
  
    
    
        const handleActiveTo = (activetoval)=>{
      
          if(activetoval != null){
      
              var dtmnt = activetoval.$M + 1;
              var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
              var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
              setactiveTomdl(dtfinalc)
  
              
          }
          
          
      }
     
   
  
      const [show3, setShow3] = useState(false);
      const [modalitem,setmodalitem] = useState({})
      
    const [currentItems, setCurrentItems] = useState([]);
    const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [pageCountfiltered, setPageCountfiltered] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);
    const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
    const [itemsPerPage,setitemsPerPage] = useState(10);
    const [paginatenumselected,setpaginatenumselected] = useState(0)
    const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
    const [pageCount2, setPageCount2] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset2, setItemOffset2] = useState(0);
    const [itemsPerPage2,setitemsPerPage2] = useState(10);
    
    const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
    const [paginatenumselected2,setpaginatenumselected2] = useState(0)
    const [filteredArr,setfilteredArr] = useState(shiftAssignApi.data)
  
  
  
    const mainfilter=(arr)=>{
        setfilteredArr(arr);    
    }
  
    const drpfunctiondepartment=(myval,myid)=>{
      setdepartment(myval)
    }
    const drpfunctioncampus=(myval,myid)=>{
      setcampus(myval)
    }
    const drpfunctiontype=(myval,myid)=>{
      settype(myval)
    }
  
  
  
    const [tempfilteredarr,settempfilteredarr] = useState([])
  
    let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
    
  
    useEffect(() => {
      const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
      const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
      settempfilteredarr(tempArr);
      setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
      
      //flag2
    }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr]);
  
        const handlePageClick = (event) => {
          const newOffset = event.selected * itemsPerPage % shiftAssignApi.data.length;        
          setpaginatenumselected(event.selected);
          setItemOffset(newOffset);
        };
        const handlePageClickfiltered = (event) => {
          const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
          setpaginatenumselectedfiltered(event.selected);
          setItemOffsetfiltered(newOffsetf);
        };
      
        
      const [idsave,setidsave]=useState(false)
      
      const [searchinputmodal,setsearchinputmodal] = useState("")
      const [rolesearchkey,setrolesearchkey] = useState("")
      const handlesearchinputmodal=(e)=>{
        setsearchinputmodal(e.target.value)      
      }
      const handlesearchmodal=()=>{
        setrolesearchkey(searchinputmodal)
      }
     
      const [formdata,setfromdata]=useState({
        usersearch:""
      })
      
  
      // populatedata
      const [name,setname] = useState("")
      const [id,setid] = useState("")
  
      const handleSearchclick =()=>{
         
          const foundItem = shiftAssignApi.data.find(item => item.id.toString() == formdata.usersearch);
  
          if (foundItem) {
            setidsave(true);
            setname(foundItem.name);
            setid(foundItem.id)
            console.log(foundItem.name);
          } else {
            setidsave(false);
          }
              
          
            mainfilter(shiftAssignApi.data) 
        
      }
     
  
     
      
      
      const optionsparentmenu = [
        {
          id:1,
          opt:"Home1"
        },
        {
          id:2,
          opt:"Home2"
        },
      ]
      const [parentmenudrp,setparentmenudrp] = useState("")
      const drpfuncparentmenu=(parentmenydrpval,myid)=>{
        setparentmenudrp(parentmenydrpval)
      }
      const [menumodalimg,setmenumodalimg] = useState("")
      
      
     
  
      const [shiftnamemod2,setshiftnamemod2] = useState("")
    const [labelshiftnamemod2,setlabelshiftnamemod2] = useState("")
    const [bordershiftnamemod2,setbordershiftnamemod2] = useState("")
    
    const [shortnamemod2,setshortnamemod2] = useState("")
    const [labelshortnamemod2,setlabelshortnamemod2] = useState("")
    const [bordershortnamemod2,setbordershortnamemod2] = useState("")
  
    const [colormod2,setcolormod2] = useState("")
    const [labelcolormod2,setlabelcolormod2] = useState("")
    const [bordercolormod2,setbordercolormod2] = useState("")
  
    const [dayofweekmod2,setdayofweekmod2] = useState("")
    const [labeldayofweekmod2,setlabeldayofweekmod2] = useState("")
    const [borderdayofweekmod2,setborderdayofweekmod2] = useState("")
  
    const [dayofmonthmod2,setdayofmonthmod2] = useState("")
    const [labeldayofmonthmod2,setlabeldayofmonthmod2] = useState("")
    const [borderdayofmonthmod2,setborderdayofmonthmod2] = useState("")
  
    const [weekofmonthmod2,setweekofmonthmod2] = useState("")
    const [labelweekofmonthmod2,setlabelweekofmonthmod2] = useState("")
    const [borderweekofmonthmod2,setborderweekofmonthmod2] = useState("")
    
    const [starttimemod2,setstarttimemod2] = useState("")
    const [labelstarttimemod2,setlabelstarttimemod2] = useState("")
    const [borderstarttimemod2,setborderstarttimemod2] = useState("")
  
    const [endtimemod2,setendtimemod2] = useState("")
    const [labelendtimemod2,setlabelendtimemod2] = useState("")
    const [borderendtimemod2,setborderendtimemod2] = useState("")
    
    const [startdatemod2,setstartdatemod2] = useState("")
    const [labelstartdatemod2,setlabelstartdatemod2] = useState("")
    const [borderstartdatemod2,setborderstartdatemod2] = useState("")
  
    const [enddatemod2,setenddatemod2] = useState("")
    const [labelenddatemod2,setlabelenddatemod2] = useState("")
    const [borderenddatemod2,setborderenddatemod2] = useState("")
    
  
     
      
  
      const drpfunctionweekofmonthmod2=(myval,myid)=>{
        setweekofmonthmod2(myval)
      }
      const drpfunctiondayofmonthmod2=(myval,myid)=>{
        setdayofmonthmod2(myval)
      }
      const drpfunctiondayofweekmod2=(myval,myid)=>{
        setdayofweekmod2(myval)
      }
  
    
      const handleStartDateMod2 = (activefromval)=>{
  
        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            setstartdatemod2(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
      const handleenddatemod2 = (activefromval)=>{
  
        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            setenddatemod2(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
    
    
    const handleInput = (e)=>{
      setfromdata({...formdata,[e.target.name]:e.target.value})
    }
  
  
  
  
    const handleCloseMod2=()=>{
      setShow3(false)
    }
    const handlesaveModal2=()=>{
      validationComp(empIDmod,setlabelempIDmod,setborderempIDmod,"Employee ID Required")
      validationComp(empnamemod,setlabelempnamemod,setborderempnamemod,"Employee Name Required")
      validationDrp(startdatemod,setlabelstartdatemod,setborderstartdatemod,"Start Date Required")
      validationDrp(enddatemod,setlabelenddatemod,setborderenddatemod,"End Date Required")
    }
  return (
    <>
          <div className="felxvaluecompmbmain">
              <div className="studentdashboardmobilewrapper">
                  <div className="mobilecontainer">
                      <div className="adminmbheading">
                          <h3>Shift Assign</h3>
                      </div>
                      <div className="admbwrap">
                          <Row>
                              <Col xs={6} className="pr5">
                              <div className="basicinputfield h40p ">

                                <p>Select Shift</p>
                                <div className="inputgap h40">
                                    <div className="dropdownwrapper">
                                        <Dropdown2 err={bordershiftmain} func={drpfuncshiftmain} myplaceholder={shiftmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                                    </div>
                                    <label>{labelshiftmain}</label>
                                    </div>
                                </div>
                              </Col>
                              <Col xs={6} className="pl5">
                              <div className="basicinputfield h40p ">

                                <p>Shift Type</p>
                                <div className="inputgap h40">
                                    <div className="dropdownwrapper">
                                        <Dropdown2 err={bordershifttypemain} func={drpfuncshifttypemain} myplaceholder={shifttypemain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                                    </div>
                                    <label>{labelshifttypemain}</label>
                                    </div>
                                </div>
                              </Col>
                              <Col xs={6} className="pr5">
                              <div className="basicinput">
                                <p>Start Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap h40">
                                <DatePicker
                                    
                                    value={startdatemain}
                                    onChange={(newvaldob)=>handleStartDatemain(newvaldob)}
                                    renderInput={(params) => <TextField style={borderstartdatemain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Start Date"
                                        }} error={false} />}
                                />
                                <label>{labelstartdatemain}</label>
                                </div>
                                </LocalizationProvider>
                            </div>
                              </Col>
                              <Col xs={6} className="pl5">
                                    <div className="basicinput">
                                <p>End Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap h40">
                                <DatePicker
                                    
                                    value={enddatemain}
                                    onChange={(newvaldob)=>handleenddatemain(newvaldob)}
                                    renderInput={(params) => <TextField style={borderenddatemain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params}inputProps={{
                                        ...params.inputProps,
                                        placeholder: "End Date"
                                        }} error={false} />}
                                />
                                <label>{labelenddatemain}</label>

                                </div>
                                </LocalizationProvider>
                            </div>
                              </Col>
                              <Col xs={6} className="pr5">
                              <div className="basicinputfield h40p ">

                                <p>Select Designaiton</p>
                                <div className="inputgap h40">
                                    <div className="dropdownwrapper">
                                        <Dropdown2 err={borderdesignationmain} func={drpfuncdesignationmain} myplaceholder={designationmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdesignation} />
                                    </div>
                                    <label>{labeldesignationmain}</label>
                                    </div>
                                </div>
                              </Col>
                              <Col xs={6} className="pl5">
                              <div className="basicinputfield h40p ">

                                <p>Campus</p>
                                <div className="inputgap h40">
                                    <div className="dropdownwrapper">
                                        <Dropdown2 err={bordercampusmain} func={drpfunccampusmain} myplaceholder={campusmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsCampus} />
                                    </div>
                                    <label>{labelcampusmain}</label>
                                    </div>
                                </div>
                              </Col>
                              <Col xs={6} className="pr5">
                              <div className="basicinputfield h40p">
                            <p>Employee ID</p>
                            <div className="inputgap h35">
                            <input style={borderemployeeIDmain ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={employeeIDmain} onChange={(e) => setemployeeIDmain(e.target.value)} />
                            <label>{labelemployeeIDmain}</label>
                            </div>
                        </div>
                              </Col>
                              <Col xs={12}>
                                <div className="purplebutton" style={{marginTop:"18px"}}>
                                    <button onClick={handleSearch} style={purplebutton200}>Search</button>
                                </div>
                              </Col>

                          </Row>
                      </div>
                      <div className="admbwrap">
                         <Row>
                          <Col xs={12}>
                            <div className="tablewrapscroll">
                               <div className="flexvaluetable hrshiftsetuptablediv">
                    <table>
                      <thead>
                        <tr>
                        <th>
                                <input
                                      type="checkbox"
                                      value={ischkmodalall}
                                      onChange={(e)=>handleChangechkall()}
                                      id="modalchk"
                                      name="modalchk"                        
                                  />
                                  </th>
                                
                            {
                              shiftAssignApi.heading.map((item,key)=>{
                                    
                                return(
                                    <>
                                  <th key={key}> <div>{item.head}</div> </th>
                                    
                                    </>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                    
                                  <td>
                                  <input
                                      type="checkbox"
                                      value={ischkmodal}
                                      onChange={(e)=>handleChangechk(e,item.empid)}
                                      id="modalchk"
                                      name="modalchk"                        
                                  />
                                  </td>
                                  <td>{item.empid}</td>
                                  <td>{item.empname}</td>
                                  <td>{item.designation}</td>
                                  <td>{item.activeshifts}</td>
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShowEdit(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                            </div>
                          </Col>
                         </Row>
                         <Row>
                    <Col lg={12} className="py-3 d-flex justify-content-center">
                      <div className="purplebutton d-inline">

                        <button className='px-4 py-2' onClick={bottomSave}>
                            Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                      </div>

                      <div className="admbwrap">
                      <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col xs={12} lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col xs={12} lg={6} className="ms-auto">
                    <div className="paginationwrapper">
                      
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col xs={12} lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {campwiseattApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col xs={12} lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                  
                </Col>
               
              </Row>
                      </div>


                      <Modal dialogClassName="mymodal" show={show3} onHide={handleCloseMod2} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Shift Setup</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  
                 <Row>
                    <Col lg={6} className='pr7'>
                        <div className="basicinputfield h40p">
                            <p>Employee ID</p>
                            <div className="inputgap h35">
                            <input style={borderempIDmod ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={empIDmod} onChange={(e) => setempIDmod(e.target.value)} />
                            <label>{labelempIDmod}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className='pl7'>
                        <div className="basicinputfield h40p">
                            <p>Employee Name</p>
                            <div className="inputgap h35">
                            <input style={borderempnamemod ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={empnamemod} onChange={(e) => setempnamemod(e.target.value)} />
                            <label>{labelempnamemod}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="flexvaluetable shiftassigntable">
                            <table className='w-100'>
                                <thead>
                                    <tr>
                                        <th>Shift Name</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>All Office(07:46 AM - 04:00 PM)</td>
                                        <td>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <div className="inputgap h35">
                                            <DatePicker
                                                
                                                value={startdatemod}
                                                onChange={(newvaldob)=>handleStartdatemod(newvaldob)}
                                                renderInput={(params) => <TextField style={borderstartdatemod == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                                    ...params.inputProps,
                                                    placeholder: "Start Date"
                                                    }} error={false} />}
                                            />
                                            <label>{labelstartdatemod}</label>
                                            </div>
                                            </LocalizationProvider>
                                        </td>
                                        <td>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <div className="inputgap h35">
                                            <DatePicker
                                                
                                                value={enddatemod}
                                                onChange={(newvaldob)=>handleEnddatemod(newvaldob)}
                                                renderInput={(params) => <TextField style={borderenddatemod == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                                    ...params.inputProps,
                                                    placeholder: "End Date"
                                                    }} error={false} />}
                                            />
                                            <label>{labelenddatemod}</label>
                                            </div>
                                            </LocalizationProvider>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Col>
                 </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleCloseMod2}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Update
                  </button>
                </Modal.Footer>

                
              </Modal>
                  </div>
              </div>
          </div>
    </>
  )
}

export default ShiftAssignCompmb